module.exports = __webpack_public_path__ + "static/img/f-marca-agua.f12d0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f-marca-agua.png
// module id = XrTG
// module chunks = 3